import { ChangeEvent, FocusEvent, FC } from 'react'
import { TextField, TextFieldProps } from 'src/components/text-field'
import { Control, RegisterOptions, useController } from 'react-hook-form'

type TextFormFieldProps = {
  name: string
  control: Control<any, any>
  rules?: Omit<RegisterOptions, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>
} & TextFieldProps

export const TextFormField: FC<TextFormFieldProps> = ({ name, control, rules, onChange, onBlur, ...rest }) => {
  const { field, fieldState } = useController({ name, control, rules })

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    field.onChange(e)
    onChange?.(e)
  }

  const handleBlur = (e: FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    field.onBlur()
    onBlur?.(e)
  }

  return (
    <TextField
      {...rest}
      name={name}
      value={field.value}
      onChange={handleChange}
      onBlur={handleBlur}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      inputRef={field.ref}
    />
  )
}
